<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Manage SKU</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <div class="flex items-end mb-base">
          <feather-icon icon="LinkIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Competitor Info</span>
        </div>

        <!-- COMPETITOR -->
        <div class="flex items-end mb-base" v-if="Object.entries(this.data).length > 0">
          <p class="text-lg font-small">{{ dataName  }}</p>
        </div>
        <div class="flex items-end" v-if="Object.entries(this.data).length > 0">
          <vs-chip :color="getStockStatusColor(tr)">{{getStockStatus(tr)}}</vs-chip>
        </div>
        <div class="flex items-end" v-if="Object.entries(this.data).length === 0">
          <vs-select v-model="dataName" label="Competitor" class="w-full" name="item-competitor" v-validate="'required'">
            <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in competitors" />
          </vs-select>
          <span class="text-danger text-sm" v-show="errors.has('item-competitor')">{{ errors.first('item-competitor') }}</span>
        </div>

        <!-- NAME -->
        <vs-input label="Product Link" v-model="dataLink" class="mt-5 w-full" name="item-link" />
        <span class="text-danger text-sm" v-show="errors.has('item-link')">{{ errors.first('item-link') }}</span>

      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || true">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      }else {
        let { category, id, img, name, link, order_status, price } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataCategory = category
        this.dataImg = img
        this.dataName = name
        this.dataLink = link
        this.dataOrder_status = order_status
        this.dataPrice = price
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {

      dataId: null,
      dataName: "",
      dataLink: "",
      dataCategory: null,
      dataImg: null,
      dataOrder_status: "pending",
      dataPrice: 0,
      dataJustIn: false,

      competitors: [
        {text:'Audio',value:'audio'},
        {text:'Computers',value:'computers'},
        {text:'Fitness',value:'fitness'},
        {text:'Appliance',value:'appliance'}
      ],

      order_status_choices: [
        {text:'Pending',value:'pending'},
        {text:'Canceled',value:'canceled'},
        {text:'Delivered',value:'delivered'},
        {text:'On Hold',value:'on_hold'}
      ],
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.dataName
    }
  },
  methods: {
    initValues() {
      if(this.data.name) return
        this.dataId = null
        this.dataName = ""
        this.dataLink = ""
        this.dataCategory = null
        this.dataOrder_status = "pending"
        this.dataPrice = 0
        this.dataImg = null,
        this.dataJustIn = false
    },
    submitData() {
      this.$validator.validateAll().then(result => {
          if (result) {
            const obj = {
              id: this.dataId,
              name: this.dataName,
              link: this.dataLink,
              img: this.dataImg,
              category: this.dataCategory,
              order_status: this.dataOrder_status,
              price: this.dataPrice,
              justIn: this.dataJustIn
            }

            if(this.dataName !== null && this.dataName.length >= 0) {
              this.$store.dispatch("dataList/updateItem", obj).catch(err => { console.error(err) })
            }else{
              delete obj.id
              obj.popularity = 0
              this.$store.dispatch("dataList/addItem", obj).catch(err => { console.error(err) })
            }

            this.$emit('closeSidebar')
            this.initValues()
          }
      })
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    getStockStatusColor() {
      if (this.dataPrice > 0)
        return this.dataJustIn ? "warning" : "success";
      return "danger";
    },
    getStockStatus(tr) {
      if (this.dataPrice > 0)
        return this.dataJustIn ? "Back in Stock" : "In Stock";
      return "Out of Stock";
    },

  },
  components: {
    VuePerfectScrollbar,
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
